import { apiClient } from '@app/api';
import { useAuditReportsGetGipMetadataVersions } from '@mi-front/api-v2';
import { DateTimeStr } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { useGipFormNewApi } from './useGipFormNewApi';

/**
 * Versions list for the GIP form, scoped by stations, dates, advertisers, and campaigns.
 * Switches between legacy logger and audit-reports APIs via `app__gip_form_new_api`.
 */
export function useGipVersionsQuery(
  params: {
    from: DateTimeStr;
    to: DateTimeStr;
    stations: string[];
    advertisers: string[];
    campaigns: string[];
  },
  enabled: boolean,
) {
  const useNewApi = useGipFormNewApi();

  const legacy = useQuery({
    queryKey: ['gip-report-versions', params],
    queryFn: () =>
      apiClient.audit.gipFetchVersions(params).then((values) => values.filter((v) => !!v)),
    enabled: !useNewApi && enabled,
  });

  const neu = useAuditReportsGetGipMetadataVersions(params, {
    query: {
      enabled: useNewApi && enabled,
      select: (versions) => versions.filter((v) => !!v),
    },
  });

  return useNewApi ? neu : legacy;
}
